<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Article</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Create New Article</h5>
      <br />
      <br />
      <b-row>
        <b-col>
          <div>
            <app-article></app-article>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
const ArticleCreate = () => import("../component/articleCreate");

export default {
  components: {
    appArticle: ArticleCreate,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>
